require('../polyfills/custom_event_polyfill')

const event = new CustomEvent('change');

const mutuallyExclusive = {
    mounted(el, binding, vnode) {
        const checkboxes = el.parentNode.parentNode.parentNode.children;

        Array.from(el.parentNode.parentNode.parentNode.children).forEach((item) => {
          const sibling = item.querySelectorAll('input')[0];
          if (el === sibling) {
            sibling.addEventListener('change', (evt) => {

            });
          }
          sibling.addEventListener('change', (evt) => {
           
            if (evt.isTrusted&&el.checked) {
              el.checked = false;
              el.dispatchEvent(new Event('change'));
              evt.target.checked = true;
              evt.target.dispatchEvent(new Event('change'));

            }
            console.log('el.checked: ' + el.checked);
          });
        });
      },
    updated(el, binding, vnode) {
    },
    beforeUpdate(el, binding, vnode) {
        const checkboxes = el.parentNode.parentNode.parentNode.children;
        Array.from(el.parentNode.parentNode.parentNode.children).forEach((item) => {
          const sibling = item.querySelectorAll('input')[0];
          if (el === sibling) {
            return;
          }
          if (el.checked) {
            sibling.checked = false;
            sibling.dispatchEvent(event);
          }
        });
      }
}

export default mutuallyExclusive;